'use client'

import { useTranslations } from 'next-intl'
import { useEffect } from 'react'

import { Routes } from '../../../../App.constants'
import useClientLogger from '../../../../lib/use-client-logger'

export default function Error({ error }: { error: Error & { digest?: string } }) {
  const clientLogger = useClientLogger()
  const t = useTranslations('error')

  useEffect(() => {
    if (!clientLogger) return
    clientLogger.error(error.message, error)
  }, [error, clientLogger])

  return (
    <main className="flex flex-col content-center items-center gap-2 p-2">
      <h1 className="text-2xl">{t('header-text')}</h1>
      <a href={Routes.HOME} aria-label={t('aria-label-home')}>
        {t('go-home-label')}
      </a>
    </main>
  )
}
